import { useReactiveVar } from '@apollo/client';

import { userStateVar } from 'core/state/userState';
import { UserRole } from 'types';

/**
 * ТЗ 0129 — продавец (SalesManager без Admin) видит только свои задачи: где он
 * исполнитель или автор. Сервер режет выборку сам (`visible_tasks`); здесь —
 * только интерфейс: без режима «Команда» и без фильтра исполнителя, которые
 * у него ничего бы не значили. Зеркало правила бэкенда.
 */
export const tasksOwnOnly = (roles: readonly string[] | null | undefined) => {
  const set = new Set(roles ?? []);
  return set.has(UserRole.SALESMANAGER) && !set.has(UserRole.ADMIN);
};

/** `tasksOwnOnly` для текущего входа. */
export const useTasksOwnOnly = (): boolean =>
  tasksOwnOnly(useReactiveVar(userStateVar).me?.roles);
